import gen from "../utils";
import pageStyle from "./index.module.less";
const config = gen({
    name: "AgentCascader",
    data() {
        return {
            pageStyle,
            id2group: {}, // 可以通过 agent_id 查 group_id
            options: []
        };
    },
    async query() {
        this.cascaderOptions = [];
        const [{ list: agentList = [] }, { list: agentGroupList = [] }] = await Promise.all([this.listAgent(), this.listAgentGroup()]);
        const id2group = {};
        const map = {};
        agentList.forEach(one => {
            const { id, name, group_id, status } = one;
            const target = (map[group_id] = map[group_id] || []);
            id2group[id] = group_id;
            target.push({ label: name, value: id, status });
        });
        this.options = agentGroupList.map(one => {
            const { id, name } = one;
            return {
                label: name,
                value: id,
                children: map[id] || []
            };
        });
        this.id2group = id2group;
    }
});
config.methods.onChange = function(value) {
    // cascader 倒数第二个为 agent_id
    this.$emit("change", value[value.length - 1]);
};
config.props.panel = Boolean;
export default config;
